<script setup="">
import { computed, inject } from "vue";

import useDrawer from "@/composables/drawer";

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  options: {
    type: Object,
    required: false
  },
  layoutClass: {
    type: String,
    required: false
  }
});

const drawer = useDrawer(props.name, props.options);

const twMerge = inject("twMerge");

const defaultLayoutClass = "fixed inset-0 left-auto z-100 h-screen w-full pb-[calc(var(--ios-padding-bottom))] pt-[calc(var(--ios-padding-top))]";
const defaultMaxWidth = "max-w-[90%] sm:max-w-sm 2xl:max-w-md";

const computedLayoutClass = computed(() => twMerge(defaultLayoutClass, props.layoutClass));
const computedMaxWidth = computed(() => twMerge(defaultMaxWidth, drawer.options?.maxWidth));

const hideDrawer = () => {
  drawer.hide();
};
</script>

<template>
  <div id="drawer" v-touch:swipe.right="hideDrawer">
    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="transform opacity-0"
      enter-to-class="transform opacity-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100"
      leave-to-class="transform opacity-0"
    >
      <div
        v-if="drawer.isOpen && drawer.options?.overlay"
        class="flex-center fixed inset-0 flex-col overflow-hidden px-4 py-6 sm:px-5"
        :class="[!drawer.options?.shadow ? 'z-0' : 'z-90']"
        @click="drawer?.options?.autoClose && drawer.hide()"
      >
        <div class="absolute inset-0 bg-gray-900/15 transition-opacity duration-300 dark:bg-zinc-950/50"></div>
      </div>
    </transition>
    <!--end::overlay-->

    <transition
      enter-active-class="ease-out transform-gpu transition-transform duration-200"
      enter-from-class="translate-x-full"
      enter-to-class="translate-x-0"
      leave-active-class="ease-in transform-gpu transition-transform duration-200"
      leave-from-class="translate-x-0"
      leave-to-class="translate-x-full"
    >
      <div v-if="drawer.isOpen" :class="[computedLayoutClass, computedMaxWidth]">
        <div class="flex h-full w-full flex-col overflow-hidden bg-white" :class="[drawer.options?.shadow ? 'border dark:border-zinc-800' : '']">
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>
